import ApiService from '../common/api.service'

class IdsService extends ApiService {

  /**
   * Encode value
   * @param {String} value Value to encode
   * @return {Promise} encoded value
   */
  encode (value, useCache = true) {
    const cacheKey = `svalue-${value}`
    const inCache = this.getFromCache(cacheKey)
    if (useCache && inCache) {
      // Get encoded value from cache
      return Promise.resolve(inCache)
    }
    return this.post(`/ids/${value}/encode`, {}, {}).then((res) => { return Promise.resolve(res.data) })
  }

  /**
   * Decode value
   * @param {String} value Value to decode
   * @return {Promise} decoded value
   */
  decode (value, useCache = true) {
    const cacheKey = `svalue-${value}`
    const inCache = this.getFromCache(cacheKey)
    if (useCache && inCache) {
      // Get decoded value from cache
      return Promise.resolve(inCache)
    }
    return this.post(`/ids/${value}/decode`, {}, {}).then((res) => { return Promise.resolve(res.data) })
  }

}

export default IdsService



// WEBPACK FOOTER //
// ./src/app/services/ids/ids.service.js